export function downloadSharedFile(msgId: string, roomName: string, token: string) {
  const url = `/artifacts/meeting_shared_files/download/${roomName}/${msgId}`;
  return fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: { 'Authorization': token },
  }).then((response) => response.ok ? Promise.resolve(response) : Promise.reject(response));
}
